import Component from '@ux/component';
import React from 'react';
import PropTypes from 'prop-types';

class Version extends Component {
  render() {
    return <span className='version'>{ this.props.value }</span>;
  }
}

Version.propTypes = {
  value: PropTypes.string
};

export default Version;
